import styled from 'styled-components';
import FeaturedAwards from 'components/FilmPage/FeaturedAwards';

export default styled(FeaturedAwards)`
  margin-bottom: 1vw;
`;
